/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 document.addEventListener("DOMContentLoaded", function() {
  //住所登録フォームの国項目非表示 (main-customers-addresses.liquid)
  HTMLElement.prototype.trigger = function(eStr) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent(eStr, true, true );
    this.dispatchEvent(e);
  }

  const specifyJapan = (domElement) => {
    selector_options = domElement.options;
    for (let i = 0; i < selector_options.length; i++) {
      if (selector_options[i].value === "Japan") {
        selector_options[i].selected = true;
        break;
      }
    }
    domElement.trigger("change");
  };

  //新規登録
  const new_address_country = document.getElementById('custom--address-new-country');
  if(new_address_country){specifyJapan(new_address_country);}
  //更新
  const edit_address_country = document.querySelectorAll('.custom--address-edit-country');
  if(edit_address_country){
    edit_address_country.forEach(element => specifyJapan(element));
    //初期値処理
    const edit_address_province = document.querySelectorAll('select[name="address[province]"]');
    edit_address_province.forEach(element => {
      if (element.dataset.default) {
        selector_options = element.options;
        for (let i = 0; i < selector_options.length; i++) {
          if (selector_options[i].innerText === element.dataset.default) {
            selector_options[i].selected = true;
            break;
          }
        }
        element.trigger("change");
      }
    });
  }
});

const createOptions = (_elem)=>{
  const elem_options_length = _elem.querySelectorAll("option").length;
  const list_brands = JSON.parse(window.localStorage.getItem('current_list_brands'));

  if(elem_options_length <= 1 && list_brands.length > 0){

    list_brands.forEach((brand)=>{
      let option = document.createElement('option');
      option.setAttribute("value", brand.brand_code);
      option.innerHTML = brand.brand_name;
      _elem.appendChild(option);
    })
  }
}

function convertClothCanBuy(clothNumber) {
  if (!clothNumber || isNaN(clothNumber)) return 0;

  if (clothNumber < 30 && clothNumber > 0) {
    return Number(clothNumber).toFixed(2);
  }

  return 30.00;
}

//2022.7.23 Add Start Function:Validation formdata
const validateData = (_form_data,_order_type,_bulk_order_flg_for_booking,_receipt_items)=>{
  //error_flg: エラーがある場合true
  //error_msg: エラーメッセージを格納
  let error_flg = false,
  error_msg_list = [];
  document.querySelectorAll('.error-message').forEach(el => el.innerHTML = '');

  const error_msg_blank = validateBlankMessage,
    error_msg_length10 = validateLength10Message,
    error_msg_length30 = validateLength30Message,
    error_msg_length35 = validateLength35Message,
    error_msg_length40 = validateLength40Message,
    error_msg_length60 = validateLength60Message,
    error_msg_length125 = validateLength125Message,
    error_msg_type_Num = validateNumberMessage,
    error_msg_type_NumAZ = validateNumberAZMessage,
    error_msg_format_YYYY_MM_DD = validateFormatYMDMessage,
    error_msg_past_day = validatePastDayMessage,
    r0t9 = /^[0-9]+$/,
    r0tZ = /^[0-9a-zA-Z-]*$/,
    rYYYY_MM_DD = /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/;

  const validateBlankReceptData = (_receipt_items, _column, _column_data, targetId) => {
    let receiptColumnMapping = {
      "顧客注文No": "Your order No.",
      "製品No": "Product No.",
      "コードNo": "Code No.",
      "ブランドCD": "Brand CD",
      "ブランド名": "Brand name"
    };
    if(_receipt_items.find((item) => item.text === _column)?.status && _column_data.trim().length === 0){
      let receiptKey = `validate${receiptColumnMapping[_column]}Column`;
      let fieldName = receiptColumnMapping[_column];
      error_msg_list.push({ message: `${fieldName} is blank.`, target: targetId });
      error_flg = true;
    }
  }

  if(_form_data.line_items[0].type === "CUT" || (_form_data.line_items[0].type === "BULK" && _order_type === "draft" )) {
    //顧客注文No
    validateBlankReceptData(_receipt_items, "顧客注文No", _form_data.order_number, 'attributes[貴社注文No]');
    //製品No
    validateBlankReceptData(_receipt_items, "製品No", _form_data.product_no, 'attributes[製品No]');
    //コードNo
    validateBlankReceptData(_receipt_items, "コードNo", _form_data.contract_no, 'attributes[コードNo]');
    //ブランドCD
    validateBlankReceptData(_receipt_items, "ブランドCD", _form_data.receipt_brand_code, 'attributes[ブランドCD]');
    //ブランド名
    validateBlankReceptData(_receipt_items, "ブランド名", _form_data.brand_name, 'attributes[ブランド名]');
  }
  if (isCheckoutForCustomer()) {
    // validate form customer email
    let customerEmail = document.getElementById('customerEmailInput');
    if (customerEmail.value.trim().length === 0) {
      error_flg = true;
      error_msg_list.push("Customer Email" + ' ' + error_msg_blank);
    }
  }

  if (_form_data.line_items[0].type === "CATALOG") {
    const {request_time, use_purpose, offer_company, planning_season, planning_season_note} = _form_data.sample_book_note;
    if (use_purpose.length == 0) {
      error_flg = true;
      error_msg_list.push({ message: validateCatalogUseColumn + ' is blank.', target: 'attributes[用途]' });
    }

    if (planning_season.length == 0) {
      error_flg = true;
      error_msg_list.push({message: validateCatalogProductionTimeColumn + ' is blank.', target: 'attributes[生産時期]'});
    }

    if (request_time.length == 0) {
      error_flg = true;
      error_msg_list.push({message: validateCatalogActualNeedTimeColumn + ' is blank.', target: 'attributes[現物必要時期]'})
    }

    if (use_purpose == "2" && (offer_company.length == 0 || offer_company.trim() === "")) {
      error_flg = true;
      error_msg_list.push({ message: validateCatalogUseColumn + ' is blank.', target: 'attributes[用途]' });
    }

    if (planning_season == "4" && (planning_season_note.length == 0 || planning_season_note.trim() === "")) {
      error_flg = true;
      error_msg_list.push({message: validateCatalogProductionTimeColumn + ' is blank.', target: 'attributes[生産時期]'});
    }
  }

  if (_form_data.line_items[0].type === "CUT" || _form_data.line_items[0].type === "PRINT") {
    let baseUnitErrorProductIds = [];
    $.each(_form_data.line_items, function(index, item) {
      if (_form_data.line_items[0].type === "CUT" && !item.sku.startsWith('cutfee')) {
        let quantityItem = $(`#CartItem--${item.variant_id} .QuantitySelector input.Only_display_QuantitySelector__TypeCut`)[0];
        let cloth = convertClothCanBuy(quantityItem.getAttribute("data-cloth"));
        let color_code = quantityItem.getAttribute("data-color_code");
        if(cloth < item.quantity) {
          error_flg = true;
          const targetId = `error_${item.variant_id}`;
          error_msg_list.push({
            message: `${item.parent_product_id}/${color_code} ${validateOutOfStockMessage} (${validateInventoryColumn}: ${cloth}yards)`,
            target: targetId
          });
        }
      } else if (_form_data.line_items[0].type === "PRINT" && !item.sku.startsWith('cutfee') && !item.sku.startsWith('printfee') && !item.sku.includes('_zuan_')) {
        let quantityItem = $(`#CartItem--${item.variant_id} .QuantitySelector input.Only_display_QuantitySelector__TypeCut`)[0];
        let cloth = convertClothCanBuy(quantityItem.getAttribute("data-cloth"));
        let color_code = quantityItem.getAttribute("data-color_code");

        if(cloth < 10 || cloth < item.quantity) {
          error_flg = true;
          const targetId = `error_${item.variant_id}`;
          error_msg_list.push({
            message: `${item.parent_product_id}/${color_code} ${validateOutOfStockMessage} (${validateInventoryColumn}: ${cloth}yards)`,
            target: targetId
          });
        }
      }
      if (!baseUnitErrorProductIds.includes(item.product_id) && !item.sku.startsWith('cutfee') && !item.sku.startsWith('printfee') && !item.sku.includes('zuan')) {
        let variantItem = $(`#CartItem--${item.variant_id}`)[0];
        let productBaseUnit = parseFloat(variantItem.getAttribute('data-base_unit'));
        if (productBaseUnit > 30) {
          productBaseUnit = 30;
        }
        if (productBaseUnit < item.quantity) {
          error_flg = true;
          baseUnitErrorProductIds.push(item.product_id);
          const targetId = `error_${item.variant_id}`;

          error_msg_list.push({
            message: `${validateQuantityLimitMessage}`,
            target: targetId
          });
        }
      }
    });
  }
  if (_form_data.line_items[0].type === "PRINT") {
    let isErrorMinQuantity = false;
    $.each(_form_data.line_items, function(_, item) {
      if (!isErrorMinQuantity) {
        if (!item.sku.startsWith('cutfee') && !item.sku.startsWith('printfee') && !item.sku.includes('zuan') && item.quantity < 11) {
          isErrorMinQuantity = true;
          error_flg = true;
          const targetId = `error_${item.variant_id}`;

          error_msg_list.push({
            message: `${validateQuantityLeastMessage}`,
            target: targetId
          });
        }
      }
    });
  }


  let today = new Date(dateToYMD(new Date()));
  if(_order_type === "booking"){
    //ーーー売約の場合ーーー
    if(_bulk_order_flg_for_booking){
      let line_item_blank_flg = false,
        line_item_format_flg = false,
        line_item_past_date_flg = false;

      for (let i = 0; i < _form_data.line_items.length; i++){
        let receiveDate = new Date(_form_data.line_items[i].receive_date);
        //取引予定日 (バルクオーダーのみ)
        if(!line_item_blank_flg && _form_data.line_items[i].receive_date.length === 0){
          //ブランクチェック(既にエラーありの場合は飛ばす)
          line_item_blank_flg = true;
          const targetId = `error_${_form_data.line_items[i].variant_id}`;

          error_msg_list.push({
            message: validatePickupDateColumn + ' ' + error_msg_blank,
            target: targetId
          });
        }else if(!line_item_format_flg && (!rYYYY_MM_DD.test(_form_data.line_items[i].receive_date) || receiveDate == "Invalid Date") && _form_data.line_items[i].receive_date.length !== 0 ){
          //フォーマットチェック(既にエラーありの場合は飛ばす)
          line_item_format_flg = true;
          const targetId = `error_${_form_data.line_items[i].variant_id}`;
          error_msg_list.push({
            message: validatePickupDateColumn + ' ' + error_msg_format_YYYY_MM_DD,
            target: targetId
          });
        } else if(!line_item_past_date_flg && receiveDate <= today) {
          line_item_past_date_flg = true;
          const targetId = `error_${_form_data.line_items[i].variant_id}`;
          error_msg_list.push({
            message: validatePickupDateColumn + ' ' + error_msg_past_day,
            target: targetId
          });
        }
      }
      if(line_item_blank_flg || line_item_format_flg || line_item_past_date_flg){
        error_flg = true;
      }
    }

    //専用伝票項目.貴社注文No
    if(!r0tZ.test(_form_data.order_number) && _form_data.order_number.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateOrderNoColumn + ' ' + error_msg_type_NumAZ, target: 'attributes[貴社注文No]' });
    }
    if(_form_data.order_number.length > 35){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateOrderNoColumn + ' ' + error_msg_length35, target: 'attributes[貴社注文No]' });
    }
    //専用伝票項目.製品No
    if(!r0tZ.test(_form_data.product_no) && _form_data.product_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateProductNoColumn + ' ' + error_msg_type_NumA, target: 'attributes[製品No]' });
    }
    if(_form_data.product_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateProductNoColumn + ' ' + error_msg_length10, target: 'attributes[製品No]' });
    }
    //専用伝票項目.コードNo
    if(!r0tZ.test(_form_data.contract_no) && _form_data.contract_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateCodeNoColumn + ' ' + error_msg_type_NumAZ, target: 'attributes[コードNo]' });
    }
    if(_form_data.contract_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateCodeNoColumn + ' ' + error_msg_length10, target: 'attributes[コードNo]' });
    }
    //専用伝票項目.ブランドCD
    if(_form_data.receipt_brand_code.length > 10){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateBrandCDColumn + ' ' + error_msg_length10, target: 'attributes[ブランドCD]' });
    }
    //専用伝票項目.ブランド名
    if(_form_data.brand_name.length > 10){
      error_flg = true;
      error_msg_list.push({ message: validateReceiptItemBeforeColumn + ' ' + validateBrandNameColumn + ' ' + error_msg_length10, target: 'attributes[ブランド名]' });
    }
  }else{
    let bulkArriveDay = new Date(_form_data.bulk_arrive_day_plan);
    if(_form_data.bulk_arrive_day_plan.trim().length === 0 && _form_data.line_items[0].type === "BULK"){
      error_flg = true;
      error_msg_list.push({ message: validateHopeDateColumn + ' ' + error_msg_blank, target: 'date_error' });
    } else if ((!rYYYY_MM_DD.test(_form_data.bulk_arrive_day_plan) || bulkArriveDay == "Invalid Date" ) && _form_data.line_items[0].type === "BULK") {
      error_flg = true;
      error_msg_list.push({ message: validateHopeDateColumn + ' ' + error_msg_format_YYYY_MM_DD, target: 'date_error' });
    }
    else if (bulkArriveDay <= today && _form_data.line_items[0].type === "BULK") {
      error_flg = true;
      error_msg_list.push({ message: validateHopeDateColumn + ' ' + error_msg_past_day, target: 'date_error' });
    }
    //ーーーそれ以外ーーー
    //無償カット情報.送付先の社会名
    if(_form_data.line_items[0].type === "BULK" && _form_data.bulk_sample_note.quantity != "0"){
      if(_form_data.bulk_sample_note.company_name.length == 0){
        error_flg = true;
        error_msg_list.push({ message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleSocialNameColumn + ' ' + error_msg_blank, target: 'name_attributes[_shipping_address][company]' });
      }
      //無償カット情報.送付先の部署名
      //if(_form_data.bulk_sample_note.department.length == 0){
       // error_flg = true;
      //  error_msg_list.push("送付先の部署名"+error_msg_blank);
      //}
      //無償カット情報.担当者
      if(_form_data.bulk_sample_note.pic.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBillingAddressColumn + ' ' + validateBulkSampleManagerColumn + ' ' + error_msg_blank, target: 'pic_error'});
      }
      //無償カット情報.郵便番号
      if(_form_data.bulk_sample_note.post_code.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSamplePostCodeColumn + ' ' + error_msg_blank, target: 'post_code_error'});
      }
      //無償カット情報.都道府県
      if(_form_data.bulk_sample_note.prefectures.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSamplePrefecturesColumn + ' ' + error_msg_blank, target: 'prefectures_error'});
      }
      //無償カット情報.市区町村
      if(_form_data.bulk_sample_note.municipalities.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleMunicipalitiesColumn + ' ' + error_msg_blank, target: 'municipalities_error'});
      }
      //無償カット情報.住所
      if(_form_data.bulk_sample_note.address.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleAddressColumn + ' ' + error_msg_blank, target: 'address_error'});
      }
      //無償カット情報.建物名・部屋番号
      if(_form_data.bulk_sample_note.apartment.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleBuildingNameColumn + ' ' + error_msg_blank, target: 'apartment_error'});
      }
      //無償カット情報.連絡番号
      if(_form_data.bulk_sample_note.phone_number.length == 0){
        error_flg = true;
        error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleContactNumberColumn + ' ' + error_msg_blank, target: 'phone_number_error'});
      }
    }
    if(_form_data.bulk_sample_note.company_name.length > 40){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleSocialNameColumn + ' ' + error_msg_length40, target: 'name_attributes[_shipping_address][company]'});
    }
    //無償カット情報.送付先の部署名
    if(_form_data.bulk_sample_note.department.length > 40){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleDepartmentNameColumn + ' ' + error_msg_length40, target: 'department_error'});
    }
    //無償カット情報.担当者
    if(_form_data.bulk_sample_note.pic.length > 40){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleManagerColumn + ' ' + error_msg_length40, target: 'pic_error'});
    }
    //無償カット情報.郵便番号
    if(!r0t9.test(_form_data.bulk_sample_note.post_code) && _form_data.bulk_sample_note.post_code.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSamplePostCodeColumn + ' ' + error_msg_type_Num, target: 'post_code_error'});
    }
    if(_form_data.bulk_sample_note.post_code.length > 10){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSamplePostCodeColumn + ' ' + error_msg_length10, target: 'post_code_error'});
    }
    //無償カット情報.都道府県
    if(!r0tZ.test(_form_data.bulk_sample_note.prefectures) && _form_data.bulk_sample_note.prefectures.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSamplePrefecturesColumn + ' ' + error_msg_type_NumAZ, target: 'prefectures_error'});
    }
    //無償カット情報.市区町村
    if(_form_data.bulk_sample_note.municipalities.length > 40){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleMunicipalitiesColumn + ' ' + error_msg_length40, target: 'municipalities_error'});
    }
    //無償カット情報.住所
    if(_form_data.bulk_sample_note.address.length > 60){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleAddressColumn + ' ' + error_msg_length60, target: 'address_error'});
    }
    //無償カット情報.建物名・部屋番号
    if(_form_data.bulk_sample_note.apartment.length > 40){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleBuildingNameColumn + ' ' + error_msg_length40, target: 'apartment_error'});
    }
    //無償カット情報.連絡番号
    if(!r0t9.test(_form_data.bulk_sample_note.phone_number) && _form_data.bulk_sample_note.phone_number.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleBeforeColumn + ' ' + validateBulkSampleContactNumberColumn + ' ' + error_msg_type_Num, target: 'phone_number_error'});
    }
    if(_form_data.bulk_sample_note.phone_number.length > 30){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleContactNumberColumn + ' ' + error_msg_length30, target: 'phone_number_error'});
    }
    //無償カット情報.備考
    if(_form_data.bulk_sample_note.note.length > 125){
      error_flg = true;
      error_msg_list.push({message: validateBulkSampleAfterColumn + ' ' + validateBulkSampleNoteColumn + ' ' + error_msg_length125, target: 'note_error'});
    }
    //専用伝票項目.貴社注文No
    if(!r0tZ.test(_form_data.order_number) && _form_data.order_number.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateOrderNoColumn + ' ' + error_msg_type_NumAZ, target: 'attributes[貴社注文No]'});
    }
    if(_form_data.order_number.length > 35){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateOrderNoColumn + ' ' + error_msg_length35, target: 'attributes[貴社注文No]'});
    }
    //専用伝票項目.製品No
    if(!r0tZ.test(_form_data.product_no) && _form_data.product_no.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateProductNoColumn + ' ' + error_msg_type_NumAZ, target: 'attributes[製品No]'});
    }
    if(_form_data.product_no.length > 10){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateProductNoColumn + ' ' + error_msg_length10, target: 'attributes[製品No]'});
    }
    //専用伝票項目.コードNo
    if(!r0tZ.test(_form_data.contract_no) && _form_data.contract_no.length !== 0){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateCodeNoColumn + ' ' + error_msg_type_NumAZ, target: 'attributes[コードNo]'});
    }
    if(_form_data.contract_no.length > 10){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateCodeNoColumn + ' ' + error_msg_length10, target: 'attributes[コードNo]'});
    }
    //専用伝票項目.ブランドCD
    if(_form_data.receipt_brand_code.length > 10){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateBrandCDColumn + ' ' + error_msg_length10, target: 'attributes[ブランドCD]'});
    }
    //専用伝票項目.ブランド名
    if(_form_data.brand_name.length > 10){
      error_flg = true;
      error_msg_list.push({message: validateReceiptItemBeforeColumn + ' ' + validateBrandNameColumn + ' ' + error_msg_length10, target: 'attributes[ブランド名]'});
    }
  }

  let formData = $('form').serializeArray().reduce(function(obj, item) {
    obj[item.name] = item.value;
    return obj;
  }, {});
  
  // validate shipping address
  validateShippingAddress(formData, error_msg_list);
  // validate billing address
  // validateBillingAddress(formData, error_msg_list);
  if (error_msg_list.length > 0) {
    error_flg = true
  }

  let companyBrands = window.localStorage.getItem('current_list_brands') ?? "[]";
  companyBrands = JSON.parse(companyBrands);
  let form_wrapper_check = "";
  const brandCodeElement = document.querySelector(`${form_wrapper_check} #company_brand_id`);
  if (_form_data.brand_code.length == 0 && _form_data.company_code != companyRepresentativeGlobal && companyBrands.length > 0) {
    if (brandCodeElement && !brandCodeElement.hidden) {
      error_flg = true;
      error_msg_list.push({ message: "Brand to order is blank.", target: 'attributes[ブランドコード]' });
    }
  }

  return {is_error:error_flg,error_msg:error_msg_list};
}

const validateShippingAddress = (formData, error_msg_list) => {
  let orderType = formData['attributes[オーダーの種類]'];
  if (orderType == 'DIGITAL') {
    return
  }
  let provinceCode = formData['attributes[_shipping_address][province_code]'];
  let countryCode = formData['attributes[_shipping_address][country]'] ?? "";
  let province = formData['attributes[_shipping_address][province]'] ?? "";
  if (countryCode == 'United States' && provinceCode) {
    province = provinceShopify[provinceCode].label;
  } else if (countryCode == 'Canada' && provinceCode) {
    province = provinceCanadaShopify[provinceCode].label;
  }
  const error_msg_length20 = "should be less than 20 characters.",
    error_msg_length30 = validateLength30Message,
    error_msg_length40 = validateLength40Message,
    error_msg_length60 = validateLength60Message;

  const data = {
    last_name: formData['attributes[_shipping_address][last_name]'] ?? "",
    first_name: formData['attributes[_shipping_address][first_name]'] ?? "",
    company: formData['attributes[_shipping_address][company]'] ?? "",
    phone: formData['attributes[_shipping_address][phone]'] ?? "",
    zip: formData['attributes[_shipping_address][zip]'] ?? "",
    province: province,
    country: countryCode,
    city: formData['attributes[_shipping_address][city]'] ?? "",
    address1: formData['attributes[_shipping_address][address1]'] ?? "",
    address2: formData['attributes[_shipping_address][address2]'] ?? "",
  };
  let suffix_message = pleaseSpecifyMessage;

  if (data.country.trim().length == 0) {
    error_msg_list.push({ message: "Country is blank.", target: 'attributes[_shipping_address][country]' });
  }

  if (data.first_name.trim().length == 0) {
    error_msg_list.push({ message: "First name is blank.", target: 'attributes[_shipping_address][first_name]' });
  }

  if ( data.first_name.trim().length > 20){
    error_msg_list.push({ message: "First name" + error_msg_length20, target: 'attributes[_shipping_address][first_name]' });
  }

  if (data.last_name.trim().length == 0){
    error_msg_list.push({ message: "Last name is blank.", target: 'attributes[_shipping_address][last_name]' });
  }

  if ( data.last_name.trim().length > 20){
    error_msg_list.push({ message: "Last name" + error_msg_length20, target: 'attributes[_shipping_address][last_name]' });
  }

  if (data.company.trim().length == 0) {
    error_msg_list.push({ message: "Company is blank.", target: 'attributes[_shipping_address][company]' });
  }

  if ( data.company.trim().length > 40){
    error_msg_list.push({ message: "Company" + error_msg_length40, target: 'attributes[_shipping_address][company]' });
  }
  
  if (data.province.trim().length == 0) {
    error_msg_list.push({ message: "State/Province is blank.", target: 'attributes[_shipping_address][province]' });
  }

  if (data.zip.trim().length == 0) {
    error_msg_list.push({ message: "Zip/Postal Code is blank.", target: 'attributes[_shipping_address][zip]' });
  }

  if (data.city.trim().length == 0) {
    error_msg_list.push({ message: "City/Town is blank.", target: 'attributes[_shipping_address][city]' });
  }

  if (data.address1.trim().length == 0) {
    error_msg_list.push({ message: "Address is blank.", target: 'attributes[_shipping_address][address1]' });
  }

  if ( data.address1.trim().length > 60){
    error_msg_list.push({ message: "Address" + error_msg_length60, target: 'attributes[_shipping_address][address1]' });
  }

  if ( data.address2.trim().length > 40){
    error_msg_list.push({ message: "Address" + error_msg_length40, target: 'attributes[_shipping_address][address2]' });
  }

  if (data.phone.trim().length == 0) {
    error_msg_list.push({ message: "Phone is blank.", target: 'attributes[_shipping_address][phone]' });
  }

  if ( data.phone.trim().length > 30){
    error_msg_list.push({ message: "Phone" + error_msg_length30, target: 'attributes[_shipping_address][phone]' });
  }

  let regexPhone = /^[0-9+-]+$/;
  if (!regexPhone.test(data.phone) && data.phone.length != 0){
    error_msg_list.push({ message: "Phone must be half-width numbers and half-width symbols [-], [+].", target: 'attributes[_shipping_address][phone]' });
  }
}

const validateBillingAddress = (formData, error_msg_list) => {
  let companyCode = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "";
  let isCompanyRepresentative = companyRepresentativeGlobal == companyCode;
  if (isCompanyRepresentative) {
    return
  }
  const data = {
    last_name: formData['attributes[_billing_address][last_name]'] ?? "",
    first_name: formData['attributes[_billing_address][first_name]'] ?? "",
  };

  if (data.last_name.trim().length == 0){
    error_msg_list.push({ message: "Last name is blank.", target: 'attributes[_billing_address][last_name]' });
  }

  if (data.first_name.trim().length == 0) {
    error_msg_list.push({ message: "First name is blank.", target: 'attributes[_billing_address][first_name]' });
  }

}

// 2022.6.25 Add Start Function:Access API
const checkoutOrder = (e,_order_type)=>{
  openFilterLoading();
  let receipt_items_raw = window.localStorage.getItem('current_company_receipt_items');
    let receipt_items =
    receipt_items_raw && receipt_items_raw.length > 0
    ? JSON.parse(receipt_items_raw)
    : (window.sessionStorage.hasOwnProperty('current_company_receipt_items') ? JSON.parse(window.sessionStorage.getItem('current_company_receipt_items')) : []);
  e.preventDefault();
  //2022.07.12 バリデーション保留
  let idError =  _order_type == 'booking' ? '#c-ErrorMsg-booking' : '#c-ErrorMsg';
  const errorElem =document.querySelector(idError);
  errorElem.innerHTML = "";

  let form_wrapper = "#non-bookingOrder"

  if(e.target.dataset.cart_type === "BULK" && _order_type === "booking"){
    form_wrapper = "#bookingOrder"
  }

  //①以下項目を取得
  const customer_id = e.target.dataset.customer_id,
    company_code = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "",
    order_items = cart_items,
    order_items_metafields = JSON.parse(e.target.dataset.line_items_type),
    note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄]"]`)?.value,
    use_purpose = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`).value : "",
    offer_company = document.querySelector(`${form_wrapper} [name="attributes[見本帳提案先]"]`).value,
    planning_season = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`).value : "",
    planning_season_note = document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`) ? document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`).value : "",
    request_time = document.querySelector(`${form_wrapper} [name="attributes[現物必要時期]"]`).value.replace("月頃",""),
    quantity = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[無償カット]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[無償カット]"]:checked`).value : "",
    company_name = document.querySelector(`${form_wrapper} [name="attributes[会社名]"]`).value,
    department = document.querySelector(`${form_wrapper} [name="attributes[部署名]"]`)?.value ?? "",
    pic = document.querySelector(`${form_wrapper} [name="attributes[担当者]"]`).value,
    post_code = document.querySelector(`${form_wrapper} [name="attributes[郵便番号]"]`).value,
    prefectures = document.querySelector(`${form_wrapper} [name="attributes[都道府県]"]`).value,
    municipalities = document.querySelector(`${form_wrapper} [name="attributes[市区町村]"]`).value,
    address = document.querySelector(`${form_wrapper} [name="attributes[住所]"]`).value,
    apartment = document.querySelector(`${form_wrapper} [name="attributes[建物名・部屋番号]"]`).value,
    phone_number = document.querySelector(`${form_wrapper} [name="attributes[連絡先番号]"]`).value,
    bulk_sample_note_note = document.querySelector(`${form_wrapper} [name="attributes[備考]"]`).value,
    credit_card_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[credit_card_check]"]`)?.checked ?? "",
    weekend_arrive_plan = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[土着希望の場合はチェックを入れてください]"]`).checked,
    mail_alert = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[商品が出荷されたらメールにて通知を受け取る]"]`).checked,
    receipt_item_order_no = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[貴社注文No]"]`).value.trim() : "",
    receipt_item_product_no = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[製品No]"]`).value.trim() : "",
    receipt_item_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ?  document.querySelector(`${form_wrapper} [name="attributes[コードNo]"]`).value.trim() : "",
    //2022.08.01 Modify 「receipt_item_brand_code・receipt_item_brand_name」取得方法を変更
    // receipt_item_brand_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).value : "",
    // receipt_item_brand_name = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelectorAll(`${form_wrapper} [name="attributes[ブランド名]"] option`)[document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).selectedIndex].textContent : "",
    brand_code = document.querySelector(`${form_wrapper} [name="attributes[ブランドコード]"]`)?.value ?? "",
    receipt_item_brand_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランドCD]"]`)?.value.trim(): "",
    receipt_item_brand_name = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`)?.value.trim(): "",
    cart_token = e.target.dataset.cart_token,

    discountCode = document.getElementById('input_discount_code') ? document.getElementById('input_discount_code').value : null;
    let bulk_arrive_day_plan = e.target.dataset.cart_type === "BULK" ? document.querySelector(`${form_wrapper} [name="attributes[希望着日]"]`).value : "";
    if (e.target.dataset.cart_type === "CUT" && weekend_arrive_plan) {
      let now = new Date();
      nextSaturday = new Date(now.setDate(now.getDate() + (((6 + 7 - now.getDay()) % 7) || 7)));
      bulk_arrive_day_plan = dateToYMD(nextSaturday);
    }

  //②Metafield項目取得用の配列を生成
  let metafields_forsearch = [];
  order_items_metafields.forEach((item)=>{
    metafields_forsearch.push({
      id:item.split("::")[0],
      digital_type:item.split("::")[1],
      unit:item.split("::")[2],
      //digital_color_additional:item.split("::")[3] ? JSON.parse(item.split("::")[3]) : {},
      // print_digital_image:item.split("::")[4]
    })
  });

  //③formデータ line_items配列を生成
  let line_items = [];
  let bulk_order_flg_for_booking = false;
  //押下ボタンで分岐
  if(_order_type === "booking"){
    //売約の場合
    order_items.forEach((item)=>{
      if(order_items[0].properties._type === "BULK"){
        //BULKオーダーの場合、フラグON(売約バリデーション用)
        bulk_order_flg_for_booking = true;
      }
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        receive_date : order_items[0].properties._type !== "BULK" ? "" : document.querySelector(`#CartItem--${item.id} [name="properties[引取予定日]"]`) ? document.querySelector(`#CartItem--${item.id} [name="properties[引取予定日]"]`).value : "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [name="properties[貴社品番]"]`) ? document.querySelector(`#CartItem--${item.id} [name="properties[貴社品番]"]`).value : "",
        quantity:item.quantity,
        fabric_weight:item.grams,
        price:item.price,
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"" //2022.07.12 制限
      })
    });
  }else{
    //それ以外
    order_items.forEach((item)=>{
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        booking_order_web_id: (item.properties && item.properties['_Booking web id']) ? item.properties['_Booking web id'] : "",
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        //2022.10.02 修正
        // quantity:item.properties?._type === "CUT" ? Number(item.quantity)  : item.quantity,
        quantity:item.properties?._type === "CUT" || (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? Number(item.quantity)  : item.quantity,
        fabric_weight:item.grams,
        price:item.price,
        type: item.properties?._type ? item.properties._type : "",
        digital_type: metafields_forsearch.find((v) => v.id == item.id) ? metafields_forsearch.find((v) => v.id == item.id).digital_type : "",
        is_default_color: item?.properties?._is_default_color,
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        design_for: item.properties?._design_for || null,
        variant_design_id: (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? item?.properties?._design_variant_id.toString() : null,
        print_digital_image:  item.properties?._print_digital_image || "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [name="properties[貴社品番]"]`) ? document.querySelector(`#CartItem--${item.id} [name="properties[貴社品番]"]`).value : "",
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"", //2022.07.12 制限
        variant_title: item.variant_title || '',
      })
    });
  }
  //④API用ヘッダー・formデータを生成

  const myHeaders = {
    "Content-Type": "application/json;charset=utf-8"
  }

  let formdata = {};

  //押下ボタンで分岐
  if(_order_type === "booking"){
    //売約の場合
    formdata = {
      "customer_id":customer_id,
      "company_code":company_code,
      "brand_code":brand_code,
      "line_items":line_items,
      "note":note,
      "mail_alert":order_items[0].properties._type === "CATALOG" || order_items[0].properties._type === "PRINT" ? "0" : mail_alert ? "1" : "0",
      "order_number":receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no":receipt_item_code,
      "receipt_brand_code":receipt_item_brand_code,
      "brand_name":receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name
    };
  }else{
    //それ以外
    formdata = {
      "customer_id":customer_id,
      "company_code":company_code,
      "brand_code":brand_code,
      "cart_token":cart_token,
      "line_items":line_items,
      "note":note,
      "sample_book_note":{
        "use_purpose":use_purpose === "自社ブランドで使用" ? "1" : use_purpose === "他社提案用（提案先を入力して下さい）" ? "2" : "",
        "offer_company":offer_company,
        "planning_season":planning_season === "期中生産" ? "1" : planning_season === "計画生産" ? "2" : planning_season === "展示会用" ? "3" : planning_season === "その他" ? "4" : "",
        "planning_season_note": planning_season_note,
        "request_time":request_time
      },
      "bulk_sample_note":{
        "quantity":quantity === "不要" ? "0" : quantity === "0.1M" ? "1" : quantity === "0.2M" ? "2" : quantity === "0.3M" ? "3" : "0",
        "company_name":company_name,
        "department":department,
        "pic":pic,
        "post_code":post_code,
        "prefectures":prefectures,
        "municipalities":municipalities,
        "address":address,
        "apartment":apartment,
        "phone_number":phone_number,
        "note":bulk_sample_note_note.replace(/\n/g,' ')
      },
      "credit_card_check": line_items[0].type === "BULK" && credit_card_check ? "1" : "0",
      "bulk_arrive_day_plan":bulk_arrive_day_plan,
      "weekend_arrive_plan":line_items[0].type === "BULK" ? "0" : weekend_arrive_plan ? "1" : "0",
      "mail_alert":line_items[0].type === "CATALOG" || line_items[0].type === "DIGITAL" ? "0" : mail_alert ? "1" : "0",
      "order_number":receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no":receipt_item_code,
      "receipt_brand_code":receipt_item_brand_code,
      "brand_name":receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name,
      "discount_code": discountCode?.trim(),
    };
  }

  //⑤バリデーション
  const valid_result = validateData(formdata,_order_type,bulk_order_flg_for_booking, receipt_items);
  document.querySelectorAll('.error-message').forEach((error) => error.remove());

  if(valid_result.is_error){
    //エラーありの場合
    //エラー表示
    const displayedTargets = new Set(); // To track which targets have already displayed their messages
    let firstErrorElement = null;
    valid_result.error_msg.forEach(({ message, target }) => {
      let errorElement = document.querySelector(`[name="${target}"]`);

      if (errorElement) {
        let parentElement;
        let errorSpan;

        // Xử lý từng trường hợp cụ thể
        if (target === 'attributes[用途]' && formdata.line_items[0].type === 'CATALOG') {
          parentElement = errorElement.closest('.custom-order-number');
        } else if (target === 'attributes[生産時期]' && formdata.line_items[0].type === 'CATALOG') {
          parentElement = errorElement.closest('.custom-order-number');
        } else if (target === 'attributes[希望着日]') {
          parentElement = errorElement.closest('p');
        } else {
          parentElement = errorElement.parentNode;
        }

        if (parentElement) {
          errorSpan = parentElement.querySelector('.error-message');

          if (!errorSpan) {
            errorSpan = document.createElement('span');
            errorSpan.className = 'error-message';
            errorSpan.style.color = 'red';
            errorSpan.textContent = message;
            errorElement.style.marginBottom = '0px';

            if (target === 'attributes[希望着日]') {
              parentElement.parentNode.insertBefore(errorSpan, parentElement.nextSibling);
            } else {
              parentElement.appendChild(errorSpan);
            }
          }

          if (!firstErrorElement) {
            firstErrorElement = parentElement;
          }

          displayedTargets.add(target);
        }
      }
    });

    const errorMessages = document.querySelectorAll('.error-message');
    if (errorMessages.length > 0) {
      const firstErrorElement = errorMessages[0].closest('.error-message').parentElement;
      firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstErrorElement.focus();
    } else {
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorElement.focus();
      }
    }

    // Now add messages to the list only if they haven't been displayed in the target element
    valid_result.error_msg.forEach(({ message, target }) => {
      if (!displayedTargets.has(target)) {
        // If the target has not been displayed, create a new <li> element
        let errorList = document.createElement("li");
        errorList.innerHTML = message;
        errorElem.appendChild(errorList);
      }
    });
    cancelFilterLoading();
  }else{
    //エラーなしの場合
    // ⑥EndPointへアクセス
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        ...formdata,
        token:globalToken
      }),
      redirect: 'follow'
    };

    const endpoint = _order_type === "booking" ? "/apps/dev-1/booking-order" : "/apps/dev-1/draft-order";
    
    changeStatusButtonForm(true);

    fetch(endpoint, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.errors){
          errorElem.innerHTML = `<span>
            ${checkoutValidateError.path_1}<br />
            ${checkoutValidateError.path_2}
            </span>`;
          //Error
          Object.keys(result.errors).forEach((item_key)=>{
            result.errors[item_key].forEach((error_msg)=>{
              //エラー表示
              let errorList = document.createElement("li");
              errorList.innerHTML = item_key + ": " + error_msg;
              errorElem.appendChild(errorList);
            });
          });
          changeStatusButtonForm(false);
          cancelFilterLoading()
        }else{
          //Success
          if(_order_type !== "booking"){
            let paymentMethods = result?.data?.fabric_payment_method?.split(',').map(method => method.trim());
            if (result?.error_type == 'discount' && renderErrorDiscount) {
              renderErrorDiscount(result);
              changeStatusButtonForm(false);
              cancelFilterLoading();
            } else if(formdata.line_items[0].type === "BULK" && paymentMethods?.length == 1 && paymentMethods[0] == "クレジットカード" && formdata?.credit_card_check == "0") {
              let errorList = document.createElement("li");
              errorList.innerHTML = "申し訳ございません、只今クレジットカードでのご注文を一時的に停止させていただいております。";
              errorElem.appendChild(errorList);
              changeStatusButtonForm(false);
              cancelFilterLoading();
            } else {
              //booking orderでない場合、受け取ったURLへ遷移
              if(result.data){
                localStorage.removeItem('bulk_tab');
                cancelFilterLoading();
                location.href = result.data.draftOrderCreate.draftOrder.invoiceUrl + '?locale=en';
              }
            }
          }

          if (_order_type === 'booking' && result.data) {
            localStorage.removeItem('receipt_items');
            fetch('/cart/clear.js', { method: "POST" });
            localStorage.removeItem('bulk_tab');
            cancelFilterLoading();
            location.href = "/pages/booking-complete";
          }
        }
      })
      .catch(error => {
        console.log('error', error.errors);
        changeStatusButtonForm(false);
        cancelFilterLoading();
      });
  }
}


function changeStatusButtonForm(isDisabled) {
  const buttonsFrom = document.querySelectorAll('form.Cart button');
  for (let i = 0; i < buttonsFrom.length; i++) {
    buttonsFrom[i].disabled = isDisabled;
  }
}
// 2022.6.25 Add End

// 2022.7.23 Add Start Display current_company on cart page
window.addEventListener('DOMContentLoaded', () => {
  const disp_current_company = document.querySelectorAll(".login_current_company");
  const current_company_name = window.localStorage.hasOwnProperty('current_company_name') ? window.localStorage.getItem('current_company_name') : "";
  if(disp_current_company && current_company_name) {
    disp_current_company.forEach((elem) => {
      elem.value = current_company_name;
    });
  }
})
// 2022.7.23 Add End

const validateTypeCart = async () => {
  let formData = $('form').serializeArray().reduce(function(obj, item) {
    obj[item.name] = item.value;
    return obj;
  }, {});

  let orderType = formData['attributes[オーダーの種類]'];
  const checkcartItems = await getCartItems();
  if (checkcartItems.length > 0 && checkcartItems[0]?.properties?._type != orderType) {
    showDialogCustom("SWITCHING ORDER TYPE?", "The cart has been updated. The page will now reload.", 'OK', () => { fnConfirmResetCartByType() },'', () => {}, true);
    return false;
  }

  return true;
}

const validateCompanyBillingAddress = async () => {
  let formData = $('form').serializeArray().reduce(function(obj, item) {
    obj[item.name] = item.value;
    return obj;
  }, {});

  let companyBillingAddress = formData['attributes[得意先コード]'];
  if (!companyBillingAddress || companyBillingAddress == '') {
    showDialogCustom('An error has occurred', 'Please reload the cart', 'OK', () => { fnConfirmResetCartByType() },'', () => {}, true);
    return false;
  }

  return true;
}

const fnConfirmResetCartByType = () => {
  window.location.reload();
}

const prepareCheckoutButton = document.getElementById('prepareCheckout');
const cartFormEl = document.querySelector('#cart');
if (prepareCheckoutButton && cartFormEl) {
  prepareCheckoutButton.onclick = async function (e) {
    e.preventDefault();
    const checkTypeCart = await validateTypeCart();
    if (!checkTypeCart) {
      return
    }
    const checkCompanyBillingAddress = await validateCompanyBillingAddress();
    if (!checkCompanyBillingAddress) {
      return
    }
    openFilterLoading();
    let form_wrapper = "#non-bookingOrder";
    const customer_id = cartFormEl.dataset.customer_id,
        company_code = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "",
        order_items = cart_items,
        note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄]"]`)?.value,
        use_purpose = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`).value : "",
        offer_company = document.querySelector(`${form_wrapper} [name="attributes[見本帳提案先]"]`).value,
        planning_season = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`).value : "",
        planning_season_note = document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`) ? document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`).value : "",
        request_time = document.querySelector(`${form_wrapper} [name="attributes[現物必要時期]"]`).value.replace("月頃",""),
        quantity = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[無償カット]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[無償カット]"]:checked`).value : "",
        company_name = document.querySelector(`${form_wrapper} [name="attributes[会社名]"]`).value,
        department = document.querySelector(`${form_wrapper} [name="attributes[部署名]"]`)?.value ?? "",
        pic = document.querySelector(`${form_wrapper} [name="attributes[担当者]"]`).value,
        post_code = document.querySelector(`${form_wrapper} [name="attributes[郵便番号]"]`).value,
        prefectures = document.querySelector(`${form_wrapper} [name="attributes[都道府県]"]`).value,
        municipalities = document.querySelector(`${form_wrapper} [name="attributes[市区町村]"]`).value,
        address = document.querySelector(`${form_wrapper} [name="attributes[住所]"]`).value,
        apartment = document.querySelector(`${form_wrapper} [name="attributes[建物名・部屋番号]"]`).value,
        phone_number = document.querySelector(`${form_wrapper} [name="attributes[連絡先番号]"]`).value,
        bulk_sample_note_note = document.querySelector(`${form_wrapper} [name="attributes[備考]"]`).value,
        credit_card_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[credit_card_check]"]`)?.checked ?? "",
        weekend_arrive_plan = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[土着希望の場合はチェックを入れてください]"]`).checked,
        mail_alert = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[商品が出荷されたらメールにて通知を受け取る]"]`).checked,
        receipt_item_order_no = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[貴社注文No]"]`).value.trim() : "",
        receipt_item_product_no = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[製品No]"]`).value.trim() : "",
        receipt_item_code = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ?  document.querySelector(`${form_wrapper} [name="attributes[コードNo]"]`).value.trim() : "",
        //2022.08.01 Modify 「receipt_item_brand_code・receipt_item_brand_name」取得方法を変更
        // receipt_item_brand_code = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).value : "",
        // receipt_item_brand_name = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelectorAll(`${form_wrapper} [name="attributes[ブランド名]"] option`)[document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).selectedIndex].textContent : "",
        brand_code = document.querySelector(`${form_wrapper} [name="attributes[ブランドコード]"]`)?.value ?? "",
        receipt_item_brand_code = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランドCD]"]`)?.value.trim(): "",
        receipt_item_brand_name = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`)?.value.trim(): "",
        cart_token = cartFormEl.dataset.cart_token,
        orderType = cartFormEl.dataset.cart_type;

        discountCode = document.getElementById('input_discount_code') ? document.getElementById('input_discount_code').value : null;
    let totalOfPrice = 0;
    let bulk_arrive_day_plan = cartFormEl.dataset.cart_type === "BULK" ? document.querySelector(`${form_wrapper} [name="attributes[希望着日]"]`).value : "";
    if (cartFormEl.dataset.cart_type === "CUT" && weekend_arrive_plan) {
      let now = new Date();
      nextSaturday = new Date(now.setDate(now.getDate() + (((6 + 7 - now.getDay()) % 7) || 7)));
      bulk_arrive_day_plan = dateToYMD(nextSaturday);
    }

    let line_items = [];
    let error_catalog_message = [];
    order_items.forEach((item)=>{
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        booking_order_web_id: (item.properties && item.properties['_Booking web id']) ? item.properties['_Booking web id'] : "",
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        //2022.10.02 修正
        // quantity:item.properties?._type === "CUT" ? Number(item.quantity)  : item.quantity,
        quantity:item.properties?._type === "CUT" || (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? Number(item.quantity)  : item.quantity,
        fabric_weight:item.grams,
        price:item.price,
        type: item.properties?._type ? item.properties._type : "",
        digital_type: '3D',
        is_default_color: item?.properties?._is_default_color,
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        design_for: item.properties?._design_for || null,
        variant_design_id: (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? item?.properties?._design_variant_id.toString() : null,
        print_digital_image:  item.properties?._print_digital_image || "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`) ? document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`).value : "",
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"", //2022.07.12 制限
        variant_title: item.variant_title || '',
      })
      if (orderType == 'CATALOG' && item.properties?._price_company == 0 && item.quantity > 1) {
        error_catalog_message.push({
          message: `${item.product_title} is over the limit.`,
          target: `error_${String(item.product_id)}`
        });
      }
    });

    let formdata = {
      "customer_id":customer_id,
      "company_code":company_code,
      "brand_code":brand_code,
      "cart_token":cart_token,
      "line_items":line_items,
      "note":note,
      "sample_book_note":{
        "use_purpose":use_purpose === "自社ブランドで使用" ? "1" : use_purpose === "他社提案用（提案先を入力して下さい）" ? "2" : "",
        "offer_company":offer_company,
        "planning_season":planning_season === "期中生産" ? "1" : planning_season === "計画生産" ? "2" : planning_season === "展示会用" ? "3" : planning_season === "その他" ? "4" : "",
        "planning_season_note": planning_season_note,
        "request_time":request_time
      },
      "bulk_sample_note":{
        "quantity":quantity === "不要" ? "0" : quantity === "0.1M" ? "1" : quantity === "0.2M" ? "2" : quantity === "0.3M" ? "3" : "0",
        "company_name":company_name,
        "department":department,
        "pic":pic,
        "post_code":post_code,
        "prefectures":prefectures,
        "municipalities":municipalities,
        "address":address,
        "apartment":apartment,
        "phone_number":phone_number,
        "note":bulk_sample_note_note.replace(/\n/g,' ')
      },
      "credit_card_check": line_items[0].type === "BULK" && credit_card_check ? "1" : "0",
      "bulk_arrive_day_plan":bulk_arrive_day_plan,
      "weekend_arrive_plan":line_items[0].type === "BULK" ? "0" : weekend_arrive_plan ? "1" : "0",
      "mail_alert":line_items[0].type === "CATALOG" || line_items[0].type === "DIGITAL" ? "0" : mail_alert ? "1" : "0",
      "order_number":receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no":receipt_item_code,
      "receipt_brand_code":receipt_item_brand_code,
      "brand_name":receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name,
      "discount_code": discountCode?.trim(),
    };
    const errorElem =document.querySelector('#c-ErrorMsg');
    errorElem.innerHTML = "";
    let receipt_items_raw = window.localStorage.getItem('current_company_receipt_items');
    let receipt_items =
    receipt_items_raw && receipt_items_raw.length > 0
    ? JSON.parse(receipt_items_raw)
    : (window.sessionStorage.hasOwnProperty('current_company_receipt_items') ? JSON.parse(window.sessionStorage.getItem('current_company_receipt_items')) : []);
    let valid_result = validateData(formdata,"draft",false, receipt_items);
    if (error_catalog_message.length > 0) {
      valid_result.is_error = true;
      valid_result.error_msg = valid_result.error_msg.concat(error_catalog_message);
    }
    document.querySelectorAll('.error-message').forEach((error) => error.remove());
    try {
      if(valid_result.is_error){
        //エラーありの場合
        //エラー表示
        const displayedTargets = new Set(); // To track which targets have already displayed their messages
        let firstErrorElement = null;
        valid_result.error_msg.forEach(({ message, target }) => {
          let errorElement = document.querySelector(`[name="${target}"]`);

          if (errorElement) {
            let parentElement;
            let errorSpan;

            if (target === 'attributes[用途]' && formdata.line_items[0].type === 'CATALOG') {
              parentElement = errorElement.closest('.custom-order-number');
            } else if (target === 'attributes[生産時期]' && formdata.line_items[0].type === 'CATALOG') {
              parentElement = errorElement.closest('.custom-order-number');
            } else if (target === 'attributes[希望着日]') {
              parentElement = errorElement.closest('p');
            } else {
              parentElement = errorElement.parentNode;
            }

            if (parentElement) {
              errorSpan = parentElement.querySelector('.error-message');

              if (!errorSpan) {
                errorSpan = document.createElement('span');
                errorSpan.className = 'error-message';
                errorSpan.style.color = 'red';
                errorSpan.textContent = message;
                errorElement.style.marginBottom = '0px';

                if (target == 'attributes[_shipping_address][province]') {
                  let targetParent = 'attributes[_shipping_address][province_code]';
                  errorElement = document.querySelector(`[name="${targetParent}"]`);
                  errorElement.style.marginBottom = '0px';
                }

                if (target === 'attributes[希望着日]') {
                  parentElement.parentNode.insertBefore(errorSpan, parentElement.nextSibling);
                } else {
                  parentElement.appendChild(errorSpan);
                }
              }

              if (!firstErrorElement) {
                firstErrorElement = parentElement;
              }

              displayedTargets.add(target);
            }
          }
        });

        const errorMessages = document.querySelectorAll('.error-message');
        if (errorMessages.length > 0) {
          const firstErrorElement = errorMessages[0].closest('.error-message').parentElement;
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstErrorElement.focus();
        } else {
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorElement.focus();
          }
        }

        // Now add messages to the list only if they haven't been displayed in the target element
        valid_result.error_msg.forEach(({ message, target }) => {
          if (!displayedTargets.has(target)) {
            // If the target has not been displayed, create a new <li> element
            let errorList = document.createElement("li");
            errorList.innerHTML = message;
            errorElem.appendChild(errorList);
          }
        });
        cancelFilterLoading();
        e.preventDefault();
        return false;
      }else{
        await removeAdditionalFeeItem();
        let additionalItem = null;

        let formDataSubmit = $('form').serializeArray().reduce(function(obj, item) {
          obj[item.name] = item.value;
          return obj;
        }, {});

        const {isError, message} = await handleShippingAddress(customer_id, formDataSubmit);
        if (isError) {
          let errorList = document.createElement("li");
          errorList.innerHTML = message;
          errorElem.appendChild(errorList);
          cancelFilterLoading();
          e.preventDefault();
          return false;
        }
        let infoCart = await getCartApi();
        let cartToken = infoCart.token;
        let response = await deleteExportCart(customer_id, cartToken);
        if (response && response.success == true) {
          await fetch('/cart/clear.js', { method: "POST" });
          cancelFilterLoading();
          showDialogCustom(
            'Your cart has expired.',
            'Your session has expired, and your cart has been cleared.',
            'Got it',
            () => { window.location.reload(); },
            '',
            () => { window.location.reload(); },
            true
          );
          return;
        }
        await handleBillingAddress();
        await updateAttributesAndReOrderLineItem(orderType, additionalItem);
      }
    } catch (error) {
      cancelFilterLoading();
      console.log(error);
      e.preventDefault();
      return false;
    }
  }
}

const provinceShopify = {
  "AL": {
    "code": "AL",
    "value": "Alabama",
    "label": "Alabama",
    "nameWithAlternates": [
      "Alabama"
    ],
  },
  "AK": {
    "code": "AK",
    "value": "Alaska",
    "label": "Alaska",
    "nameWithAlternates": [
      "Alaska"
    ],
  },
  "AS": {
    "code": "AS",
    "value": "American Samoa",
    "label": "American Samoa",
    "nameWithAlternates": [
      "American Samoa"
    ],
  },
  "AZ": {
    "code": "AZ",
    "value": "Arizona",
    "label": "Arizona",
    "nameWithAlternates": [
      "Arizona"
    ],
  },
  "AR": {
    "code": "AR",
    "value": "Arkansas",
    "label": "Arkansas",
    "nameWithAlternates": [
      "Arkansas"
    ],
  },
  "CA": {
    "code": "CA",
    "value": "California",
    "label": "California",
    "nameWithAlternates": [
      "California"
    ],
  },
  "CO": {
    "code": "CO",
    "value": "Colorado",
    "label": "Colorado",
    "nameWithAlternates": [
      "Colorado"
    ],
  },
  "CT": {
    "code": "CT",
    "value": "Connecticut",
    "label": "Connecticut",
    "nameWithAlternates": [
      "Connecticut"
    ],
  },
  "DE": {
    "code": "DE",
    "value": "Delaware",
    "label": "Delaware",
    "nameWithAlternates": [
      "Delaware"
    ],
  },
  "FM": {
    "code": "FM",
    "value": "Micronesia",
    "label": "Micronesia",
    "nameWithAlternates": [
      "Federated States of Micronesia",
      "Micronesia"
    ],
  },
  "FL": {
    "code": "FL",
    "value": "Florida",
    "label": "Florida",
    "nameWithAlternates": [
      "Florida"
    ],
  },
  "GA": {
    "code": "GA",
    "value": "Georgia",
    "label": "Georgia",
    "nameWithAlternates": [
      "Georgia"
    ],
  },
  "GU": {
    "code": "GU",
    "value": "Guam",
    "label": "Guam",
    "nameWithAlternates": [
      "Guam"
    ],
  },
  "HI": {
    "code": "HI",
    "value": "Hawaii",
    "label": "Hawaii",
    "nameWithAlternates": [
      "Hawaii"
    ],
  },
  "ID": {
    "code": "ID",
    "value": "Idaho",
    "label": "Idaho",
    "nameWithAlternates": [
      "Idaho"
    ],
  },
  "IL": {
    "code": "IL",
    "value": "Illinois",
    "label": "Illinois",
    "nameWithAlternates": [
      "Illinois"
    ],
  },
  "IN": {
    "code": "IN",
    "value": "Indiana",
    "label": "Indiana",
    "nameWithAlternates": [
      "Indiana"
    ],
  },
  "IA": {
    "code": "IA",
    "value": "Iowa",
    "label": "Iowa",
    "nameWithAlternates": [
      "Iowa"
    ],
  },
  "KS": {
    "code": "KS",
    "value": "Kansas",
    "label": "Kansas",
    "nameWithAlternates": [
      "Kansas"
    ],
  },
  "KY": {
    "code": "KY",
    "value": "Kentucky",
    "label": "Kentucky",
    "nameWithAlternates": [
      "Kentucky"
    ],
  },
  "LA": {
    "code": "LA",
    "value": "Louisiana",
    "label": "Louisiana",
    "nameWithAlternates": [
      "Louisiana"
    ],
  },
  "ME": {
    "code": "ME",
    "value": "Maine",
    "label": "Maine",
    "nameWithAlternates": [
      "Maine"
    ],
  },
  "MH": {
    "code": "MH",
    "value": "Marshall Islands",
    "label": "Marshall Islands",
    "nameWithAlternates": [
      "Marshall Islands"
    ],
  },
  "MD": {
    "code": "MD",
    "value": "Maryland",
    "label": "Maryland",
    "nameWithAlternates": [
      "Maryland"
    ],
  },
  "MA": {
    "code": "MA",
    "value": "Massachusetts",
    "label": "Massachusetts",
    "nameWithAlternates": [
      "Massachusetts"
    ],
  },
  "MI": {
    "code": "MI",
    "value": "Michigan",
    "label": "Michigan",
    "nameWithAlternates": [
      "Michigan"
    ],
  },
  "MN": {
    "code": "MN",
    "value": "Minnesota",
    "label": "Minnesota",
    "nameWithAlternates": [
      "Minnesota"
    ],
  },
  "MS": {
    "code": "MS",
    "value": "Mississippi",
    "label": "Mississippi",
    "nameWithAlternates": [
      "Mississippi"
    ],
  },
  "MO": {
    "code": "MO",
    "value": "Missouri",
    "label": "Missouri",
    "nameWithAlternates": [
      "Missouri"
    ],
  },
  "MT": {
    "code": "MT",
    "value": "Montana",
    "label": "Montana",
    "nameWithAlternates": [
      "Montana"
    ],
  },
  "NE": {
    "code": "NE",
    "value": "Nebraska",
    "label": "Nebraska",
    "nameWithAlternates": [
      "Nebraska"
    ],
  },
  "NV": {
    "code": "NV",
    "value": "Nevada",
    "label": "Nevada",
    "nameWithAlternates": [
      "Nevada"
    ],
  },
  "NH": {
    "code": "NH",
    "value": "New Hampshire",
    "label": "New Hampshire",
    "nameWithAlternates": [
      "New Hampshire"
    ],
  },
  "NJ": {
    "code": "NJ",
    "value": "New Jersey",
    "label": "New Jersey",
    "nameWithAlternates": [
      "New Jersey"
    ],
  },
  "NM": {
    "code": "NM",
    "value": "New Mexico",
    "label": "New Mexico",
    "nameWithAlternates": [
      "New Mexico"
    ],
  },
  "NY": {
    "code": "NY",
    "value": "New York",
    "label": "New York",
    "nameWithAlternates": [
      "New York"
    ],
  },
  "NC": {
    "code": "NC",
    "value": "North Carolina",
    "label": "North Carolina",
    "nameWithAlternates": [
      "North Carolina"
    ],
  },
  "ND": {
    "code": "ND",
    "value": "North Dakota",
    "label": "North Dakota",
    "nameWithAlternates": [
      "North Dakota"
    ],
  },
  "MP": {
    "code": "MP",
    "value": "Northern Mariana Islands",
    "label": "Northern Mariana Islands",
    "nameWithAlternates": [
      "Northern Mariana Islands"
    ],
  },
  "OH": {
    "code": "OH",
    "value": "Ohio",
    "label": "Ohio",
    "nameWithAlternates": [
      "Ohio"
    ],
  },
  "OK": {
    "code": "OK",
    "value": "Oklahoma",
    "label": "Oklahoma",
    "nameWithAlternates": [
      "Oklahoma"
    ],
  },
  "OR": {
    "code": "OR",
    "value": "Oregon",
    "label": "Oregon",
    "nameWithAlternates": [
      "Oregon"
    ],
  },
  "PW": {
    "code": "PW",
    "value": "Palau",
    "label": "Palau",
    "nameWithAlternates": [
      "Palau"
    ],
  },
  "PA": {
    "code": "PA",
    "value": "Pennsylvania",
    "label": "Pennsylvania",
    "nameWithAlternates": [
      "Pennsylvania"
    ],
  },
  "PR": {
    "code": "PR",
    "value": "Puerto Rico",
    "label": "Puerto Rico",
    "nameWithAlternates": [
      "Puerto Rico"
    ],
  },
  "RI": {
    "code": "RI",
    "value": "Rhode Island",
    "label": "Rhode Island",
    "nameWithAlternates": [
      "Rhode Island"
    ],
  },
  "SC": {
    "code": "SC",
    "value": "South Carolina",
    "label": "South Carolina",
    "nameWithAlternates": [
      "South Carolina"
    ],
  },
  "SD": {
    "code": "SD",
    "value": "South Dakota",
    "label": "South Dakota",
    "nameWithAlternates": [
      "South Dakota"
    ],
  },
  "TN": {
    "code": "TN",
    "value": "Tennessee",
    "label": "Tennessee",
    "nameWithAlternates": [
      "Tennessee"
    ],
  },
  "TX": {
    "code": "TX",
    "value": "Texas",
    "label": "Texas",
    "nameWithAlternates": [
      "Texas"
    ],
  },
  "UT": {
    "code": "UT",
    "value": "Utah",
    "label": "Utah",
    "nameWithAlternates": [
      "Utah"
    ],
  },
  "VT": {
    "code": "VT",
    "value": "Vermont",
    "label": "Vermont",
    "nameWithAlternates": [
      "Vermont"
    ],
  },
  "VA": {
    "code": "VA",
    "value": "Virginia",
    "label": "Virginia",
    "nameWithAlternates": [
      "Virginia"
    ],
  },
  "WA": {
    "code": "WA",
    "value": "Washington",
    "label": "Washington",
    "nameWithAlternates": [
      "Washington"
    ],
  },
  "DC": {
    "code": "DC",
    "value": "Washington DC",
    "label": "Washington DC",
    "nameWithAlternates": [
      "District of Columbia",
      "Washington DC"
    ],
  },
  "WV": {
    "code": "WV",
    "value": "West Virginia",
    "label": "West Virginia",
    "nameWithAlternates": [
      "West Virginia"
    ],
  },
  "WI": {
    "code": "WI",
    "value": "Wisconsin",
    "label": "Wisconsin",
    "nameWithAlternates": [
      "Wisconsin"
    ],
  },
  "WY": {
    "code": "WY",
    "value": "Wyoming",
    "label": "Wyoming",
    "nameWithAlternates": [
      "Wyoming"
    ],
  },
  "VI": {
    "code": "VI",
    "value": "U.S. Virgin Islands",
    "label": "U.S. Virgin Islands",
    "nameWithAlternates": [
      "Virgin Islands",
      "U.S. Virgin Islands"
    ],
  },
  "AA": {
    "code": "AA",
    "value": "Armed Forces Americas",
    "label": "Armed Forces Americas",
    "nameWithAlternates": [
      "Armed Forces Americas"
    ],
  },
  "AE": {
    "code": "AE",
    "value": "Armed Forces Europe",
    "label": "Armed Forces Europe",
    "nameWithAlternates": [
      "Armed Forces Europe"
    ],
  },
  "AP": {
    "code": "AP",
    "value": "Armed Forces Pacific",
    "label": "Armed Forces Pacific",
    "nameWithAlternates": [
      "Armed Forces Pacific"
    ],
  }
}


const provinceCanadaShopify = {
  "AB": {
    "code": "AB",
    "value": "Alberta",
    "label": "Alberta",
    "nameWithAlternates": [
      "Alberta"
    ]
  },
  "BC": {
    "code": "BC",
    "value": "British Columbia",
    "label": "British Columbia",
    "nameWithAlternates": [
      "British Columbia"
    ]
  },
  "MB": {
    "code": "MB",
    "value": "Manitoba",
    "label": "Manitoba",
    "nameWithAlternates": [
      "Manitoba"
    ]
  },
  "NB": {
    "code": "NB",
    "value": "New Brunswick",
    "label": "New Brunswick",
    "nameWithAlternates": [
      "New Brunswick"
    ]
  },
  "NL": {
    "code": "NL",
    "value": "Newfoundland and Labrador",
    "label": "Newfoundland and Labrador",
    "nameWithAlternates": [
      "Newfoundland and Labrador"
    ]
  },
  "NS": {
    "code": "NS",
    "value": "Nova Scotia",
    "label": "Nova Scotia",
    "nameWithAlternates": [
      "Nova Scotia"
    ]
  },
  "ON": {
    "code": "ON",
    "value": "Ontario",
    "label": "Ontario",
    "nameWithAlternates": [
      "Ontario"
    ]
  },
  "PE": {
    "code": "PE",
    "value": "Prince Edward Island",
    "label": "Prince Edward Island",
    "nameWithAlternates": [
      "Prince Edward Island"
    ]
  },
  "QC": {
    "code": "QC",
    "value": "Quebec",
    "label": "Quebec",
    "nameWithAlternates": [
      "Quebec"
    ]
  },
  "SK": {
    "code": "SK",
    "value": "Saskatchewan",
    "label": "Saskatchewan",
    "nameWithAlternates": [
      "Saskatchewan"
    ]
  },
  "NT": {
    "code": "NT",
    "value": "Northwest Territories",
    "label": "Northwest Territories",
    "nameWithAlternates": [
      "Northwest Territories"
    ]
  },
  "YT": {
    "code": "YT",
    "value": "Yukon",
    "label": "Yukon",
    "nameWithAlternates": [
      "Yukon"
    ]
  },
  "NU": {
    "code": "NU",
    "value": "Nunavut",
    "label": "Nunavut",
    "nameWithAlternates": [
      "Nunavut"
    ]
  }
};

function handleBillingAddress() {
  let companyCode = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "";
  let isCompanyRepresentative = companyRepresentativeGlobal == companyCode;
  if (isCompanyRepresentative) {
    const shippingAddress = {
      last_name: document.getElementById('checkout_shipping_address_last_name')?.value ?? "",
      first_name: document.getElementById('checkout_shipping_address_first_name')?.value ?? "",
      company: document.getElementById('checkout_shipping_address_company')?.value ?? "",
      department: document.getElementById('checkout_shipping_address_dept')?.value ?? "",
      zip: document.getElementById('checkout_shipping_address_zip')?.value ?? "",
      province_code: document.getElementById('checkout_shipping_address_province_code')?.value ?? "",
      province: document.getElementById('checkout_shipping_address_province')?.value ?? "",
      city: document.getElementById('checkout_shipping_address_city')?.value ?? "",
      address1: document.getElementById('checkout_shipping_address_address1')?.value ?? "",
      address2: document.getElementById('checkout_shipping_address_address2')?.value ?? "",
      phone: document.getElementById('checkout_shipping_address_phone')?.value ?? "",
      country: document.getElementById('checkout_shipping_address_country')?.value ?? "",
    }

    const billingForm = {
      last_name: document.getElementById('checkout_billing_address_last_name'),
      first_name: document.getElementById('checkout_billing_address_first_name'),
      company: document.getElementById('checkout_billing_address_company'),
      department: document.getElementById('checkout_billing_address_dept'),
      zip: document.getElementById('checkout_billing_address_zip'),
      province_code: document.getElementById('checkout_billing_address_province_code'),
      province: document.getElementById('checkout_billing_address_province'),
      city: document.getElementById('checkout_billing_address_city'),
      address1: document.getElementById('checkout_billing_address_address1'),
      address2: document.getElementById('checkout_billing_address_address2'),
      phone: document.getElementById('checkout_billing_address_phone'),
      country: document.getElementById('checkout_billing_address_country'),
    }

    billingForm.last_name.value = shippingAddress?.last_name ?? "";
    billingForm.first_name.value = shippingAddress?.first_name ?? "";
    billingForm.company.value = shippingAddress?.company ?? "";
    billingForm.department.value = shippingAddress?.department ?? "";
    billingForm.zip.value = shippingAddress?.zip ?? "";
    billingForm.province_code.value = shippingAddress?.province_code ?? "";
    billingForm.province.value = shippingAddress?.province ?? "";
    billingForm.city.value = shippingAddress?.city ?? "";
    billingForm.address1.value = shippingAddress?.address1 ?? "";
    billingForm.address2.value = shippingAddress?.address2 ?? "";
    billingForm.phone.value = shippingAddress?.phone ?? "";
    billingForm.country.value = shippingAddress?.country ?? "";
  }
}

async function handleShippingAddress(customer_id, formData) {
  const provinceCode = formData['attributes[_shipping_address][province_code]'];
  const selectedCountry = formData['attributes[_shipping_address][country]'];
  let provinceData;
  if (selectedCountry === 'United States') {
      provinceData = provinceShopify;
  } else if (selectedCountry === 'Canada') {
      provinceData = provinceCanadaShopify;
  } else {
      provinceData = {};
  }

  const dataUpsertAddress = {
    last_name: formData['attributes[_shipping_address][last_name]'] ?? "",
    first_name: formData['attributes[_shipping_address][first_name]'] ?? "",
    company: formData['attributes[_shipping_address][company]'] ?? "",
    phone: formData['attributes[_shipping_address][phone]'] ?? "",
    zip: formData['attributes[_shipping_address][zip]'] ?? "",
    province: provinceData[provinceCode]?.value ?? "",
    city: formData['attributes[_shipping_address][city]'] ?? "",
    country: selectedCountry ?? "",
    address1: formData['attributes[_shipping_address][address1]'] ?? "",
    address2: formData['attributes[_shipping_address][address2]'] ?? "",
    default: 1,
    department: formData['attributes[_shipping_address][department]'] ?? "",
    shopify_customer_id: customer_id,
    customer_id : customer_id,
    token: globalToken,
  };
  
  let orderType = formData['attributes[オーダーの種類]'];
  if (orderType == 'DIGITAL') {
    return {
      isError: false,
      message: ""
    }
  }
  let isCreateAddress = (formData?.['create_shipping_checkbox'] || formData?.['add-new-address']) ? true : false;
  isCrateAddress = isCreateAddress || (formData['attributes[_shipping_address][shipping_address_id]'] ?? false);
  if (isCreateAddress) {
    let response = await createCustomerAddressWhenCheckout(dataUpsertAddress);
    if (response.status != 200 && response.status != 201) {
      return {
        isError: true,
        message: "Shipping address: This address is already registered."
      }
    }
  } else {
    dataUpsertAddress['address_id'] = formData['attributes[_shipping_address][shipping_address_id]'] ?? "";
    let response = await editCustomerAddressWhenCheckout(dataUpsertAddress);
    if (response.status != 200 && response.status != 201) {
      return {
        isError: true,
        message: "Shipping address: An error occurred while updating the address. Please check if the entered information is correct."
      }
    }
  }
  return {
    isError: false,
    message: ""
  }
}

async function editCustomerAddressWhenCheckout(dataCreateAddress) {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json;charset=utf-8"
    },
    body: JSON.stringify(dataCreateAddress),
  };
  const response = await fetch("/apps/dev-1/address/update", requestOptions)
  return await response.json()
}

async function createCustomerAddressWhenCheckout(dataCreateAddress) {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json;charset=utf-8"
    },
    body: JSON.stringify(dataCreateAddress),
  };
  const response = await fetch("/apps/dev-1/address/create", requestOptions)
  return await response.json()

}

async function removeAdditionalFeeItem() {
  const cartInfo = await getCartApi();
  const cartItems = cartInfo.items;
  if (typeof cartItems !== 'undefined') {
    const removeParam = {};
    for (let i = 0; i < cartItems.length; i++) {
      if (cartItems[i].handle == 'deposit' || cartItems[i].handle == 'balance') {
        removeParam[`${cartItems[i].key}`] = 0;
      }
    }
    if (Object.keys(removeParam).length > 0) {
      $.ajax({
        url: "/cart/update.js",
        method: 'POST',
        dataType: 'json',
        data: {
          updates: removeParam
        },
        success: function(response) {
        },
        error: function(response) {
        }
      });
    }
  }
}

async function getBalanceItem(orderType, balancePrice) {
  try {
    const balaceItem = await fetch('/products/balance.js', {});
    if (balaceItem) {
      const product = await balaceItem.json();
      return {
        "id": product.variants[0].id,
        "quantity": 1,
        "properties": {
          "_type": orderType,
          "_item_type": 'balance',
          "_price_company": balancePrice,
          "_has_custom_price": true
        }
      };
    }
    return false;
  } catch (error) {
    console.error('Error 2:', error);
    e.preventDefault();
    return false;
  }
}

async function updateAttributesAndReOrderLineItem(orderType, additionalItem = null) {
  const cartItems = await getCartItems();
  if (isCheckout) {
    cartItems.reverse();
  }
  let itemAddCarts = {};
  itemAddCarts['items'] = [];
  let itemsRemove = {};

  if ((orderType === 'DIGITAL' || orderType === 'CATALOG') && Array.isArray(cartItems)) {
    cartItems.forEach((cartItem) => {
      itemAddCarts['items'].push({
        id: cartItem?.id,
        quantity: cartItem?.quantity,
        properties: cartItem?.properties
      })
      itemsRemove = {
        ...itemsRemove,
        [cartItem?.key]: 0
      }
    });
  }

  if (orderType === 'CUT' || orderType === 'PRINT') {
    if (additionalItem) {
      itemAddCarts['items'].push(additionalItem);
    }
    let itemsFabric = [],
        itemsCutFee = {},
        itemsPrintFee = {},
        itemsDesignFee = {};

    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];
      itemsRemove = {
        ...itemsRemove,
        [cartItems[i].key]: 0
      }
      if (item.sku.includes('_zuan_')) {
        if (typeof itemsDesignFee[item.properties['_variant_id_fabric']] == 'undefined') {
          itemsDesignFee[item.properties['_variant_id_fabric']] = {};
        }
        itemsDesignFee = {
          ...itemsDesignFee,
          [item.properties['_variant_id_fabric']]: {
            ...itemsDesignFee[item.properties['_variant_id_fabric']],
            [item.id]: item
          }
        }
      } else if (item.sku.includes('printfee_')) {
        if (typeof itemsPrintFee[item.properties['_variant_id_fabric']] == 'undefined') {
          itemsPrintFee[item.properties['_variant_id_fabric']] = {};
        }
        itemsPrintFee = {
          ...itemsPrintFee,
          [item.properties['_variant_id_fabric']]: {
            ...itemsPrintFee[item.properties['_variant_id_fabric']],
            [item.properties['_design_variant_id']]: item
          }
        }
      } else if (item.sku.includes('cutfee_')) {
        if (orderType == 'CUT') {
          itemsCutFee = {
            ...itemsCutFee,
            [item.properties['_variant_id_fabric']]: item
          }
        } else { // PRINT
          if (typeof itemsCutFee[item.properties['_variant_id_fabric']] == 'undefined') {
            itemsCutFee[item.properties['_variant_id_fabric']] = {};
          }
          itemsCutFee = {
            ...itemsCutFee,
            [item.properties['_variant_id_fabric']]: {
              ...itemsCutFee[item.properties['_variant_id_fabric']],
              [item.properties['_design_variant_id']]: item
            }
          }
        }
      } else {
        itemsFabric.push(item);
      }
    }
    for (let i = 0; i < itemsFabric.length; i++) {
      const variantFabricId = itemsFabric[i].id;
      const designItemId = itemsFabric[i].properties?._design_variant_id;
      // add design item
      if (typeof itemsDesignFee[variantFabricId] != 'undefined' && typeof itemsDesignFee[variantFabricId][designItemId] != 'undefined') {
        itemAddCarts['items'].push({
          id: itemsDesignFee[variantFabricId][designItemId].id,
          quantity: itemsDesignFee[variantFabricId][designItemId].quantity,
          properties: itemsDesignFee[variantFabricId][designItemId]?.properties || {},
        });
      }
      // add print item
      if (typeof itemsPrintFee[variantFabricId] != 'undefined' && typeof itemsPrintFee[variantFabricId][designItemId] != 'undefined') {
        itemAddCarts['items'].push({
          id: itemsPrintFee[variantFabricId][designItemId].id,
          quantity: itemsPrintFee[variantFabricId][designItemId].quantity,
          properties: itemsPrintFee[variantFabricId][designItemId]?.properties || {},
        });
      }

      // add cut item
      if (orderType == 'CUT') {
        if (typeof itemsCutFee[variantFabricId] != 'undefined') {
          itemAddCarts['items'].push({
            id: itemsCutFee[variantFabricId].id,
            quantity: itemsCutFee[variantFabricId].quantity,
            properties: itemsCutFee[variantFabricId]?.properties || {},
          });
        }
      } else {
        if (typeof itemsCutFee[variantFabricId] != 'undefined' && typeof itemsCutFee[variantFabricId][designItemId] != 'undefined') {
          itemAddCarts['items'].push({
            id: itemsCutFee[variantFabricId][designItemId].id,
            quantity: itemsCutFee[variantFabricId][designItemId].quantity,
            properties: itemsCutFee[variantFabricId][designItemId]?.properties || {},
          });
        }
      }
      // add fabrics
      itemAddCarts['items'].push({
        id: itemsFabric[i].id,
        quantity: itemsFabric[i].quantity,
        properties: {
          ...(itemsFabric[i]?.properties || {}),
          '_price_in_company_prd_discount_table' : itemsFabric[i]?.properties?._original_price_company,
          '_先方品番': document.querySelector(`input[name="attributes[貴社品番-${itemsFabric[i].id}]"]`)?.value || ''
        },
      })
    }
  }
  let res = await updateAttributeCartAndRemoveItem(itemsRemove, itemAddCarts, orderType);
  cancelFilterLoading();
  localStorage.removeItem('receipt_items');
  if (res) {
    window.location.href = '/checkout';
  }
}

function isCheckoutForCustomer() {
  return prepareCheckoutButton.getAttribute('data-checkout-for-customer') === 'true';
}

async function getInfoCart() {
  let res = await fetch('/cart.js', {});
  const resBody = await res.json();
  return resBody;
}

async function getCartItems() {
  let res = await fetch('/cart.js', {});
  const resBody = await res.json();
  return resBody.items;
}

async function updateAttributeCartAndRemoveItem(itemsRemove = {}, itemsAdd = null) {
  const allCartAttributes = $('#cart').serializeArray();
  const lastNameCustomer = customerInfoLogin.last_name || "";
  const firstNameCustomer = customerInfoLogin.first_name || "";
  const companyUserLogin = customerInfoLogin.company || "";
  const companyCodeCustomerLogin = window.localStorage.getItem('current_company') || "";
  const companyNameCustomerLogin = window.localStorage.getItem('current_company_name') || "";
  let attributes = {};
  for (let i = 0; i < allCartAttributes.length; i++) {
    const attributeItem = allCartAttributes[i];
    const attributesItemName = attributeItem.name;
    if (attributesItemName.startsWith('attributes[') && attributeItem.value) {
      const attributesItemNameArray = attributesItemName.match(/\[([^]]+)]|([^\[\]]+)/g);
      if (attributesItemNameArray.length === 2) {
        attributes = {
          ...attributes,
          [attributesItemNameArray[1]]: attributeItem.value
        };
      } else if (attributesItemNameArray.length === 3) {
        if (typeof attributes[attributesItemNameArray[1]] == 'undefined') {
          attributes = {
            ...attributes,
            [attributesItemNameArray[1]]: {}
          };
        }
        attributes = {
          ...attributes,
          [attributesItemNameArray[1]]: {
            ...attributes[attributesItemNameArray[1]],
            [attributesItemNameArray[2]]: attributeItem.value
          }
        };
      }
    }
  }

  attributes._customer_info = {
    last_name: lastNameCustomer,
    first_name: firstNameCustomer,
    company_code: companyCodeCustomerLogin,
    company_name: companyNameCustomerLogin,
    company_user_login: companyUserLogin
  };

  attributes = {
    ...attributes,
    "is_checkout": true,
  }

  const bodyUpdateCart = {
    updates: itemsRemove,
    attributes
  }

  const titleCartErrorMessage = 'Error';
  const defaultCartErrorMessage = 'An unexpected error has occurred. Please try again later.';
  const handleCartApiError = () => {
    tata.error(titleCartErrorMessage, defaultCartErrorMessage);
  };

  const updateResponse = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(bodyUpdateCart)
  });

  if (!updateResponse.ok) {
    handleCartApiError();
    return false;
  }

  if (itemsAdd) {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(itemsAdd)
    });

    if (!addResponse.ok) {
      handleCartApiError();
      window.location.reload();
      return false;
    }
    return true;
  }
  return true;
}

function checkUserOfCompanyRepresentatives(representativeCompanyCode) {
  const companyCode = localStorage.getItem('current_company') || '';
  return companyCode === representativeCompanyCode;
}

const getValueHasKeyInAttribute = (key, attributes) => {
  return attributes.find((attr) => attr.name === key)?.value || null;
}

function resetAttributeCartState(resetAttributes = {}) {
  for (const attrKey in resetAttributes) {
    resetAttributes[attrKey] = "";
  }

  return resetAttributes;
}

async function updateCartApi(attributes, changedItems = {}) {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };
  const updateCartUrl = "/cart/update.js";
  const bodyPayload =  {
    attributes: attributes,
    updates: changedItems
  }

  try {
    await fetch(updateCartUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(bodyPayload)
    })
  } catch(error) {
    throw error?.message
  }
}

async function getCartApi() {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };
  const updateCartUrl = "/cart.js";

  try {
    const res = await fetch(updateCartUrl, {
      method: "GET",
      headers: headers,
    })
    return res.json();
  } catch(error) {
    throw error?.message
  }
}

async function resetAttributeCart() {
  try {
    const cart = await getCartApi();
    if (!cart || !cart.items || cart?.items.length > 0 || Object.keys(cart.attributes).length === 0 ) return;
    const resetedAttribute = resetAttributeCartState(cart.attributes);
    await updateCartApi(resetedAttribute);
  } catch (error) {
    console.error("Reset attribute fail", error)
  }
}

async function deleteExportCart(customerId, cartToken) {
  try {
    const companyCode = localStorage.getItem('current_company') || '';
    
    if (!customerId || !companyCode || !cartToken) {
      return;
    }

    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        shopify_customer_id: customerId,
        company_code: companyCode,
        cart_token: cartToken,
        token: globalToken,
        customer_id: customerId
      })
    };

    let url = `apps/app-proxy/export-cart/delete`;
    const response = await fetch(url, requestOptions);
    
    if (response.ok) {
      const data = await response.json();
      console.log('Export cart deleted successfully');
      return data;
    } else {
      const errorData = await response.json();
      console.error('Failed to delete export cart:', errorData);
      return errorData;
    }
  } catch (error) {
    console.error('Error deleting export cart:', error);
    return { success: false, message: error.message };
  }
}